import { RailsCategory } from '@sls-react/typings/services/rails/item';
import getCategorySlugsFromArray from '@sls-react/utils/getCategorySlugsFromArray';

export default function categoryAnalytics(categories: RailsCategory[]) {
  if (!categories) {
    return { category_1: '', category_2: '' };
  }

  return getCategorySlugsFromArray(categories).reduce<{
    category_1: string;
    category_2: string;
    category_3?: string;
  }>(
    (prev, cur, i) => ({
      ...prev,
      [`category_${i + 1}`]: cur,
    }),
    { category_1: '', category_2: '' },
  );
}
